(function (Drupal, once) {

  Drupal.behaviors.bendrejatWorksAside = {

    attach(context) {

      once('bendrejat-works-aside', '.region-aside', context).forEach((aside) => {

        let related = aside.querySelector(
          '.block-views-blockartistadmin-works-view-block-4'
        );

        let research = aside.querySelector(
          '.block-views-blockartistadmin-works-view-block-6'
        );

        // no relevant block
        if (!related && !research) {
          return;
        }

        // only related block
        if (related && !research) {
          aside.style.height = `${related.offsetHeight}px`;
          aside.classList.add('is-related-active','is-related-only');
          return;
        }

        // only research block
        if (research && !related) {
          aside.style.height = `${research.offsetHeight}px`;
          aside.classList.add('is-research-active','is-research-only');
          return;
        }

        // block titles
        const relatedTitle = related.querySelector('h2');
        const researchTitle = research.querySelector('h2');

        if (!relatedTitle || !researchTitle) {
          return;
        }

        const updateAsideHeight = () => {

          const activeBlock = aside.classList.contains('is-research-active')
            ? research
            : related;

          aside.style.height = `${activeBlock.offsetHeight}px`;

        };

        updateAsideHeight();

        relatedTitle.addEventListener('click', () => {
          aside.classList.remove('is-research-active');
          updateAsideHeight();
        });

        researchTitle.addEventListener('click', () => {
          aside.classList.add('is-research-active');
          updateAsideHeight();
        });

        window.addEventListener('resize', updateAsideHeight);

      });

    }

  };

})(Drupal, once);